import { rgba } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.section`
  color: ${({ theme }) => rgba(theme.deprecated_.colors.text, 0.8)};
  letter-spacing: 0.03em;
  line-height: 150%;
`;
